<div class="container-fluid tw-relative tw-bg-black tw-pb-12 tw-overflow-hidden">
    <!-- Fondo decorativo inferior derecho -->
    
  
    <!-- Degradado inferior izquierdo -->
  <img
  src="assets/elipsis/orange.svg"
  alt=""
  class="tw-absolute tw-left-[0px] tw-top-[-5px] lg:tw-top-[-10px] lg:tw-left-[10px] tw-opacity-35 tw-blur-md"
/>
<img
  src="assets/elipsis/blue.svg"
  alt=""
  class="tw-absolute tw-top-[-5px] tw-right-[0px] lg:tw-top-[-10px] lg:right-[10px] tw-opacity-35 tw-blur-md"
/>
  
  
  
    <!-- Contenido principal -->
    <div class="tw-relative tw-z-10">
      <!-- Encabezado -->
      <div class="tw-max-w-6xl tw-mx-auto tw-px-4">
        <h2 class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight">
          <span class="tw-text-white">
            CONÉCTATE A
            <span class="tw-text-[#F67011] tw-drop-shadow-md">NUESTROS PLANES</span>
            DE FIBRA
          </span>
        </h2>
        <p class="tw-text-center tw-text-xl tw-font-montserrat tw-font-light tw-text-gray-200 tw-mt-2 tw-mb-8 tw-leading-relaxed">
          Onelink ofrece
          <span class="tw-font-medium tw-text-white"> un servicio prepago y sin complicaciones, sin cláusulas</span>,
          ni cargos ocultos para reactivar tu conexión, con planes asimétricos diseñados para una experiencia óptima garantizada.
          
        </p>
      </div>
  
      <!-- Grid de tarjetas -->
      <div class="tw-max-w-6xl tw-mx-auto tw-px-4 tw-py-2">
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-2 tw-gap-6 tw-mt-4">
          <app-card-price  [plan]="'500'" [text]="'Navega, haz streaming en HD y usa redes sociales fácilmente.'" [price]="'30'"></app-card-price>
          <app-card-price [plan]="'800'" [text]="'Ideal para navegación, streaming en 4K y videojuegos en línea.'" [price]="'38'"></app-card-price>
          <app-card-price [plan]="'900'" [text]="'Disfruta de alto rendimiento en hogares con múltiples dispositivos.'" [price]="'52'"></app-card-price>
          <app-card-price [plan]="'1500'" [text]="'Ideal para streaming, descargas y trabajo remoto sin límites.'" [price]="'88'"></app-card-price>
        </div>
      </div>
  
     
    </div>
  </div>
  